import React from 'react';

const Step4_Confirmation = ({
  selectedClinic,
  wabaId,
  phoneNumbers,
  selectedPhoneNumber,
  onBack,
  onComplete,
  loading,
  error
}) => {
  const selectedPhone = phoneNumbers.find(p => p.id === selectedPhoneNumber);

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">Step 4: Complete Onboarding</h3>
        <p className="text-gray-600 mb-6">Review your selections and complete the onboarding process.</p>
      </div>

      <div className="bg-gray-50 rounded-lg p-6 space-y-4">
        <div className="flex justify-between items-center">
          <span className="font-medium text-gray-700">Clinic:</span>
          <span className="text-gray-900">{selectedClinic?.name || 'N/A'}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="font-medium text-gray-700">WABA ID:</span>
          <span className="text-gray-900">{wabaId}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="font-medium text-gray-700">Phone Number:</span>
          <span className="text-gray-900">
            {selectedPhone?.phone_number || 'N/A'}
          </span>
        </div>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-md p-4">
          <p className="text-red-800">{error}</p>
        </div>
      )}

      <div className="flex justify-between">
        <button
          onClick={onBack}
          className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Back
        </button>
        <button
          onClick={() => onComplete({
            waba_id: wabaId,
            phone_number_id: selectedPhoneNumber,
            phone_number_name: selectedPhone?.name || '',
            phone_number: selectedPhone?.phone_number || '',
            clid: selectedClinic?.id
          })}
          disabled={loading}
          className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
        >
          {loading ? 'Completing...' : 'Complete Onboarding'}
        </button>
      </div>
    </div>
  );
};

export default Step4_Confirmation;
